import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "vab-icon-dui",
  "use": "vab-icon-dui-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol viewBox=\"0 0 16 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vab-icon-dui\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.4492 0.833291C15.8885 1.27263 15.8885 1.98494 15.4492 2.42428L7.01692 10.8565C6.54832 11.3251 5.78852 11.3251 5.31989 10.8565L1.13029 6.66689C0.690946 6.22761 0.690946 5.51526 1.13029 5.07591C1.56962 4.63656 2.28194 4.63656 2.72128 5.07591L6.16842 8.52306L13.8582 0.833291C14.2975 0.393949 15.0099 0.393949 15.4492 0.833291Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol